import { render, staticRenderFns } from "./TermsofUse.vue?vue&type=template&id=7e934f92&scoped=true&"
import script from "./TermsofUse.vue?vue&type=script&lang=js&"
export * from "./TermsofUse.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/AboutUs-pc.css?vue&type=style&index=0&id=7e934f92&scoped=true&lang=css&"
import style1 from "../assets/css/AboutUs-phone.css?vue&type=style&index=1&id=7e934f92&scoped=true&lang=css&"
import style2 from "./TermsofUse.vue?vue&type=style&index=2&id=7e934f92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e934f92",
  null
  
)

export default component.exports